import React, {useState} from 'react';

/**
 * VmPricingApiService exposes the two end points we will use in the Calculator UI to retrieve the pricing comparison chart and Excel report.
 */
const VmPricingApiService = () => {
    
    async function getPricingComparison(reCaptchaToken, region, tableData) {
    
        let vmConfigurations = new Array();
        tableData.forEach(vm => {
            let apiVm = {
                "vmName": vm.vmName,
                "vmCount": vm.numberOfVMs,
                "CPU": vm.vCPUPerVM,
                "OsType": vm.osType,
                "Memory": vm.memoryPerVM,
                "Storage": vm.storagePerVM
            };

            vmConfigurations.push(apiVm);
        });

        const response = fetch(`/api/cloudpricingcalculator/getpricingcomparison`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Region: region,
                ReCaptchaToken: reCaptchaToken,
                Configurations: vmConfigurations
            })
        });

        return response;
    }

    async function getExcel(reCaptchaToken, region, tableData) {
    
        let vmConfigurations = new Array();
        tableData.forEach(vm => {
            let apiVm = {
                "vmName": vm.vmName,
                "vmCount": vm.numberOfVMs,
                "CPU": vm.vCPUPerVM,
                "OsType": vm.osType,
                "Memory": vm.memoryPerVM,
                "Storage": vm.storagePerVM
            };

            vmConfigurations.push(apiVm);
        });

        const response = fetch(`/api/cloudpricingcalculator/excel`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                Region: region,
                ReCaptchaToken: reCaptchaToken,
                Configurations: vmConfigurations
            })
        });

        return response;
    }

    return {
        getPricingComparison,
        getExcel
    }
};

export default VmPricingApiService();